import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useFavorites } from "../context/FavoritesContext";

export const FavoriteButton = ({ product, className = "" }) => {
  const { isFav, toggle } = useFavorites();
  const fav = isFav(product.code);

  const onClick = (e) => {
    e.preventDefault(); e.stopPropagation();
    toggle(product.code);
    toast(fav ? "Quitado de favoritos" : "Guardado en favoritos", { duration: 1800 });
  };

  return (
    <button
      data-testid={`fav-${product.code}`} onClick={onClick} aria-pressed={fav}
      title={fav ? "Quitar de favoritos" : "Guardar en favoritos"}
      className={`inline-flex items-center justify-center rounded-full transition-colors ${
        fav ? "bg-[#E02424] text-white" : "bg-white/90 text-gray-600 hover:text-[#E02424]"} ${className}`}
    >
      <Heart className={`w-4 h-4 ${fav ? "fill-current" : ""}`} />
    </button>
  );
};
